import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { DataGrid, esES, GridColDef } from '@mui/x-data-grid';
import useWindowDimensions from '../../../../infrastructure/utils/hooks/useDimensions';
import { ToolbarList } from '../../../../infrastructure/common/toolbar';

export const PaymentCommitmentsV: React.FC<{
  dataCommiments?: any;
  loadingPayrollCommunications: boolean;
}> = ({ dataCommiments, loadingPayrollCommunications }) => {
  const theme = useTheme();
  const { h } = useWindowDimensions();
  const styles = {
    buttonText: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '0.8em',
      fontWeight: 'bold',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: '#fff',
      [theme.breakpoints.down('md')]: {
        display: 'inline-flex',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    headerContent: {
      marginBottom: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'end',
    },
    icon: {
      fontSize: '10px',
      color: '#fff',
      marginLeft: 0,
      marginRight: 0,
      [theme.breakpoints.up('sm')]: {
        fontSize: '20px',
        color: '#fff',
      },
    },
    button: {
      background: theme.palette.secondary.main,
      height: '30px',
      padding: '0 15px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      boxShadow: '0px 3px 5px 0px #dcdcdc',
    },
    containerDate: {
      borderRadius: '5px',
      marginTop: '20px',
      backgroundColor: 'white',
    },
    grid: {
      padding: '10px',
      marginBottom: '5px',
      width: '100%',
      marginLeft: 0,
      display: 'flex',
      marginTop: '5px',
    },
    boxToModal: {
      width: '100px',
      height: 'auto',
      backgroundColor: 'transparent',
    },
    header: {
      fontWeight: 'bold',
      fontSize: '1.1em',
      color: `${theme.palette.primary.dark}`,
      textAlign: 'left',
      marginBottom: '5px',
    },
  };
  const columns: GridColDef[] = [
    {
      field: 'identification',
      headerName: 'IDENTIFICACIÓN',
      headerAlign: 'center',
      align: 'right',
      flex: 0.03,
      cellClassName: 'cellRow',
    },
    {
      field: 'client',
      headerName: 'NOMBRES Y APELLIDOS',
      headerAlign: 'center',
      align: 'left',
      flex: 0.05,
      cellClassName: 'cellRow',
    },
    {
      field: 'dateCall',
      headerName: 'FECHA LLAMADA',
      headerAlign: 'center',
      align: 'center',
      flex: 0.03,
      cellClassName: 'cellRow',
    },

    {
      field: 'typeOfCall',
      headerName: 'TIPO DE LLAMADA',
      headerAlign: 'center',
      align: 'left',
      flex: 0.03,
      cellClassName: 'cellRow',
    },
    {
      field: 'description',
      headerName: 'DESCRIPCIÓN',
      headerAlign: 'center',
      align: 'left',
      flex: 0.1,
      cellClassName: 'cellRow',
    },
    {
      field: 'commitmentToPay',
      headerName: 'COMPROMISO DE PAGO',
      headerAlign: 'center',
      align: 'center',
      flex: 0.05,
      cellClassName: 'cellRow',
    },
  ];
  return (
    <div
      style={{
        padding: '5px 20px',
        width: '100%',
        height: 'inherit',
      }}>
      <Typography sx={styles.header}>Lista de compromisos de pago</Typography>

      <Box sx={{ height: h(80), background: '#fff', width: '100%', borderRadius: '5px' }}>
        <DataGrid
          sx={{ border: 'none' }}
          rows={dataCommiments || []}
          columns={columns || []}
          loading={loadingPayrollCommunications}
          getRowId={(row) => row.pctId}
          pageSize={20}
          density="compact"
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: ToolbarList,
          }}
        />
      </Box>
    </div>
  );
};
